module.exports = __webpack_public_path__ + "static/media/duke-mccaffrey.85860684.jpg";